import React from 'react';
import Dialog from 'components/Dialog';
import './TooManyAttachmentsDialog.scss';
import Button from 'components/Button';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
export interface Props {
  onHideButtonClicked: () => void;
  max: number;
}
const TooManyAttachmentsDialog = ({ max, onHideButtonClicked }: Props) => {
  const title = `Choose ${max} or fewer attachments`;
  const text = `To share more than ${max} attachments, send a link to a Google Drive folder or send multiple messages.`;
  return (
    <Dialog
      className="TooManyAttachmentsDialog"
      onRequestHide={onHideButtonClicked}
      title={title}
      layout="buttonInside"
    >
      {text}{' '}
      <Link href={LinkConstants.TOO_MANY_ATTACHMENTS_LEARN_MORE} target="_blank">
        Learn more
      </Link>
      <Button color="mascot" onClick={onHideButtonClicked}>
        Close
      </Button>
    </Dialog>
  );
};

export default TooManyAttachmentsDialog;
